import React, { useEffect } from 'react';
import { Dashboard as DashboardLayout } from 'layouts';
import CardTable from './CardTable';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { cleanCard } from 'js/actions/cardAction';

import { makeStyles } from '@mui/styles';
import styles from './styles';
import { SpeedDial } from '@mui/material';
import { Add } from '@mui/icons-material';
const useStyles = makeStyles(styles);

export default function Card() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { meterId } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(cleanCard());
  }, []);

  return (
    <DashboardLayout>
      <div className={classes.root}>
        <CardTable props={state.id} meterId={meterId} />
      </div>
      <SpeedDial
        sx={{
          position: 'fixed',
          bottom: 32,
          right: 32,
          '& .MuiFab-primary': {
            backgroundColor: '#00AFEF',
            color: '#fff',
            width: '60px',
            height: '60px',
            fontSize: '1.5em',
            '&:hover': {
              backgroundColor: 'rgb(0, 146, 199)',
            },
          },
        }}
        ariaLabel="SpeedDial basic example"
        icon={<Add />}
        onClick={() => navigate(`/newCard/${meterId}/${state.id}`)}
      />
    </DashboardLayout>
  );
}
